import DeliveryService from "./DeliveryService";

export default DeliveryService;
